import { Container, Spinner, Text } from '@lego/klik-ui';
import type { ReactElement } from 'react';

type FullType = 'full-screen' | 'full-container';
type FullSizeSpinnerProps = {
  type?: FullType;
  text?: string;
};

export const FullSizeSpinner = (props: FullSizeSpinnerProps): ReactElement => {
  const containerHeight = props.type === 'full-container' ? '100%' : '100vh';

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: containerHeight,
        minHeight: containerHeight,
        width: '100%',
      }}
    >
      <Spinner size="lg" />
      {props.text && <Text className="heading-2xl">{props.text}</Text>}
    </div>
  );
};
